<template>
  <div>
    <Vcode :show="isShow"
           slider-text="拖动滑块完成验证"
           fail-text="验证失败，请重试"
           success-text="验证成功"
           :range="5"
           @success="success"
           @close="close"
    />
  </div>
  <van-nav-bar
      title="注册新账户"
      left-text="返回"
      left-arrow
      fixed
      @click-left="onClickLeft"
  />
  <br/>
  <br/>
  <br/>
  <van-cell-group inset>
    <van-cell title="信息登记" label="请填写以下信息完成账户注册。审核通过后即可预约训练课程。" />
  </van-cell-group>
  <br/>
  <van-form @submit="onSubmit">
    <van-cell-group inset>
      <van-cell title="账户信息"/>
      <van-field
          v-model="username"
          name="賬號"
          label="用户名"
          placeholder="仅支持字母和数字"
          :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
          v-model="password"
          type="password"
          name="密碼"
          label="密码"
          placeholder="请设置密码"
          :rules="[{ required: true, message: '请填写密码' }]"
      />
      <van-field
          v-model="password_confirm"
          type="password"
          name="密碼"
          label="确认密码"
          placeholder="请再次输入密码"
          :rules="[{ required: true, message: '请再次填写密码' }]"
      />
    </van-cell-group>
    <br/>
    <van-cell-group inset>
      <van-cell title="学员信息"/>
      <van-field
          v-model="student_name"
          name="姓名"
          label="姓名"
          placeholder="请输入真实姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
          v-model="student_id"
          name="学员编号"
          label="学员编号"
          placeholder="请输入学员编号"
          :rules="[{ required: true, message: '请填写学员编号' }]"
      />
      <van-field
          v-model="member_id"
          name="档案标识"
          label="档案标识"
          placeholder="请输入档案标识"
          :rules="[{ required: true, message: '请填写档案标识' }]"
      />
    </van-cell-group>
    <br/>
    <van-cell-group inset>
      <van-cell title="联系信息"/>
      <van-field
          v-model="phone"
          type="tel"
          name="手机号"
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <van-field
          v-model="wechat_id"
          name="微信号"
          label="微信号"
          placeholder="用于日常联系"
          :rules="[{ required: true, message: '请填写微信号' }]"
      />
      <van-field
          v-model="email"
          name="邮箱"
          label="邮箱"
          placeholder="可留空"
      />
    </van-cell-group>
    <br/>
    <van-row justify="center">
      <van-space :size="20">
        <van-button round block type="warning" :disabled="disabled" native-type="submit" icon="guide-o" >
          提交注册
        </van-button>
        <van-button round block type="default" :disabled="disabled" icon="replay" @click="onRewrite">
          重新填写
        </van-button>
      </van-space>
    </van-row>
  </van-form>
  <br/>
</template>

<script>
import {showFailToast, showSuccessToast, showToast, Toast} from 'vant';
export default {
  setup() {
    const onClickLeft = () => history.back();
    return {
      onClickLeft,
    };
  },
  data() {
    return{
      username: '',
      password: '',
      password_confirm: '',
      student_name: '',
      student_id:'',
      member_id:'',
      phone:'',
      email:'',
      wechat_id:'',
      isShow: false,
      disabled: false
    };
  },
  methods: {
    onSubmit(){
      if(this.password !== this.password_confirm){
        this.password = this.password_confirm = "";
        showFailToast("两次输入的密码不一致，请重新填写。");
        return;
      }
      this.isShow = true;
    },
    onRewrite(){
      this.username = '';
      this.password = '';
      this.password_confirm = '';
      this.student_name = '';
      this.member_id = '';
      this.student_id = '';
      this.wechat_id = '';
      this.phone = '';
      this.email = '';
    },
    success() {
      this.disabled = true;
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/;
      if(pattern.test(this.password) === false){
        this.disabled = false;
        showToast("密码至少8位，且须包含大小写字母、数字和特殊字符");
        this.isShow = false;
        return;
      }
      this.$http.post(`/user/register?username=${encodeURIComponent(this.username)}&password=${encodeURIComponent(this.password)}&name=${encodeURIComponent(this.student_name)}&card_id=${encodeURIComponent(this.member_id)}&phone=${encodeURIComponent(this.phone)}&wechat_id=${encodeURIComponent(this.wechat_id)}
&student_id=${encodeURIComponent(this.student_id)}&email=${encodeURIComponent(this.email)}`)
          .then(data => {
            console.log(data);
            if(data.status !== 200){
              showFailToast("系统异常");
            }
            if(data.data.status === -1){
              showFailToast(data.data.data);
              this.password = this.password_confirm = '';
            }
            if(data.data.status === 0){
              showSuccessToast(data.data.data);
              this.$router.push("/login");
            }
            this.disabled = false;
          })
          .catch(error =>{
            showFailToast("网络连接异常");
            this.disabled = false;
          });
      this.isShow = false; // 通过验证后，需要手动隐藏模态框
    },
    close() {
      this.isShow = false;
    }
  }
};
</script>
